export default __webpack_public_path__ + "static/media/7.890a9917.svg";